import {
  createSlice,
} from '@reduxjs/toolkit';
import reject from 'lodash/reject';
import concat from 'lodash/concat';
import find from 'lodash/find';
import get from 'lodash/get';
import setEntitiesState, { setBaseState } from '../../../../../store/utils/setStoreState.js';
import { amountSum } from '../../../../../shared/utils/commonUtils.js';

const paymentMethodsSlice = createSlice({
  name: 'paymentMethods',
  initialState: {
    entities: {
      paymentMethods: {},
    },
    usedPaymentMethods: [],
    /*
      ** the structure is like below,
      **
      **  {
      **     "paymentMethodType": "CREDIT_CARD",
      **     "amount": 10.00,
      **     "paymentAccountId": 111
      **  },
      */
    paymentsInfoUsedForPay: [],
  },
  reducers: {
    setPaymentMethods: setEntitiesState('paymentMethods'),
    setPaymentsInfoUsedForPay: setBaseState('paymentsInfoUsedForPay'),
    setUsedPaymentMethods: setBaseState('usedPaymentMethods'),
    updatePaymentsInfoUsedForPay: (state, action) => {
      const {
        paymentInfoObj, findPaymentConfig,
      } = action.payload;
      const {
        paymentsInfoUsedForPay,
      } = state;

      const findPaymentObj = find(paymentsInfoUsedForPay, findPaymentConfig);

      if (!findPaymentObj) {
        state.paymentsInfoUsedForPay = concat(paymentsInfoUsedForPay, [ paymentInfoObj ]);
      } else {
        state.paymentsInfoUsedForPay = concat(reject(paymentsInfoUsedForPay,
          findPaymentConfig), [{ ...findPaymentObj, ...paymentInfoObj }]);
      }
    },
    deletePaymentsInfoUsedForPay: (state, action) => {
      const findPaymentConfig = action.payload;
      const {
        paymentsInfoUsedForPay,
      } = state;
      state.paymentsInfoUsedForPay = reject(paymentsInfoUsedForPay, findPaymentConfig);
    },
  },
});

export const {
  setPaymentMethods,
  setPaymentsInfoUsedForPay,
  setUsedPaymentMethods,
  updatePaymentsInfoUsedForPay,
  deletePaymentsInfoUsedForPay,
} = paymentMethodsSlice.actions;

export default paymentMethodsSlice.reducer;

export const selectTotalInputAmount = (state) => {
  const totalInputAmount = state.paymentMethods.paymentsInfoUsedForPay.map(item => item.amount)
    .reduce((result, amount) => amountSum(result, amount), 0);
  return totalInputAmount;
};

export const getPennyRounding = (state) => {
  return get(state, [ 'paymentMethods', 'entities', 'paymentMethods', 'cashInfo', 'pennyRounding' ], {});
};
